import { render } from "./ConfidenceTag.vue?vue&type=template&id=366cf4be&ts=true"
import script from "./ConfidenceTag.vue?vue&type=script&lang=ts"
export * from "./ConfidenceTag.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__